(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["mo-feel-press"] && !Shopify.designMode) return;
  try {
    
(function () {
  function classifyMaterial(s) {
    s = s.toLowerCase();
    if (s.indexOf('purple') > -1 || s.indexOf('grid') > -1) return 'grid';
    if (s.indexOf('tempur') > -1) return 'foam';
    if (s.indexOf('hybrid') > -1 || s.indexOf('coil') > -1 || s.indexOf('innerspring') > -1 || s.indexOf('pocketed') > -1 || s.indexOf('spring') > -1) return 'coil';
    if (s.indexOf('memory foam') > -1 || s.indexOf('visco') > -1 || s.indexOf('foam') > -1) return 'foam';
    if (s.indexOf('latex') > -1) return 'latex';
    return 'coil';
  }
  var MATS = {
    foam:  { k: 26,  c: 10.5, attack: 14, phrase: 'slow, contouring recovery — the classic memory-foam response' },
    coil:  { k: 180, c: 15,   attack: 22, phrase: 'quick snap-back with a little spring — that’s the coils' },
    latex: { k: 260, c: 32,   attack: 24, phrase: 'fast, buoyant recovery' },
    grid:  { k: 320, c: 30,   attack: 26, phrase: 'instant, buoyant snap-back' }
  };
  function parseFirmness(fr, feel) {
    var m = (fr || '').match(/([\d.]+)\s*out of 10/i);
    if (m) return Math.min(10, Math.max(1, parseFloat(m[1])));
    var s = ((fr || '') + ' ' + (feel || '')).toLowerCase();
    if (/ultra firm|extra firm/.test(s)) return 9;
    if (/medium-firm|cushion firm/.test(s)) return 6.5;
    if (/firm/.test(s)) return 8;
    if (/medium-soft/.test(s)) return 4;
    if (/medium/.test(s)) return 5;
    if (/plush|soft/.test(s)) return 3.5;
    return 5.5;
  }

  function init(root) {
    if (root.dataset.fpressInit) return;
    root.dataset.fpressInit = '1';
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var stage = root.querySelector('[data-fpress-stage]');
    var img = stage && stage.querySelector('img');
    if (!img) return;

    var matKey = classifyMaterial(root.dataset.vendor + ' ' + root.dataset.feel + ' ' + root.dataset.construction);
    var mat = MATS[matKey];
    var firmness = parseFirmness(root.dataset.firmness, root.dataset.feel);
    var depthTune = (parseInt(root.dataset.depth || '100', 10) || 100) / 100;
    /* softer bed = deeper dent: 3/10 ~11.5% of frame height, 9/10 ~3.4% */
    var depthFrac = Math.min(0.115, Math.max(0.034, 0.16 - 0.014 * firmness)) * depthTune;
    var zoneTop = (parseInt(root.dataset.zoneTop || '52', 10) || 52) / 100;
    var zoneBot = (parseInt(root.dataset.zoneBottom || '78', 10) || 78) / 100;
    var zoneMid = (zoneTop + zoneBot) / 2;

    var N = 96;
    var d = new Float32Array(N), v = new Float32Array(N);
    var canvas, ctx, off, W = 0, H = 0, dpr = 1;
    var pressing = false, px = 0.5, pyT = zoneMid, bandY = zoneMid, pressFrac = 0, hoverFrac = 0;
    var running = false, lastT = 0, firedPress = false, ghost = null;

    function readout() {
      var el = root.querySelector('[data-fpress-readout]');
      if (!el) return;
      var feel = root.dataset.feel || '';
      el.innerHTML = '';
      el.appendChild(document.createTextNode(feel ? feel : 'This bed'));
      var em = document.createElement('em');
      em.textContent = mat.phrase.charAt(0).toUpperCase() + mat.phrase.slice(1) + '.';
      el.appendChild(em);
      el.hidden = false;
    }

    function build() {
      var iw = img.naturalWidth, ih = img.naturalHeight;
      if (!iw || !ih) return false;
      var cw = stage.clientWidth;
      if (!cw) return false;
      dpr = Math.min(1.75, window.devicePixelRatio || 1);
      W = Math.round(cw * dpr);
      H = Math.round(W * (ih / iw));
      off = document.createElement('canvas');
      off.width = W; off.height = H;
      off.getContext('2d').drawImage(img, 0, 0, W, H);
      if (!canvas) {
        canvas = document.createElement('canvas');
        canvas.setAttribute('role', 'img');
        canvas.setAttribute('tabindex', '0');
        canvas.setAttribute('aria-label', 'Interactive firmness demo: press or drag across the mattress image and it compresses and recovers like the real bed. ' + (root.dataset.feel || ''));
        stage.appendChild(canvas);
        bind();
      }
      canvas.width = W; canvas.height = H;
      canvas.style.aspectRatio = W + ' / ' + H;
      ctx = canvas.getContext('2d');
      img.style.display = 'none';
      root.classList.add('is-live');
      draw();
      return true;
    }

    function flushRun(a, b, cw) {
      var sx = Math.floor(a * cw);
      var sw = Math.min(W - sx, Math.ceil((b - a) * cw) + 1);
      if (sw > 0) ctx.drawImage(off, sx, 0, sw, H, sx, 0, sw, H);
    }

    /* local dent bubble: content above the press stretches into the dent wall,
       content below compresses toward the base; outside the bubble nothing moves */
    function draw() {
      ctx.clearRect(0, 0, W, H);
      var cw = W / N, runStart = -1, maxDip = 0;
      var yP = bandY * H;
      var rT = Math.min(yP, 0.17 * H);
      var rB = Math.min(H - yP, 0.16 * H);
      for (var i = 0; i < N; i++) {
        var dip = d[i] * H;
        if (dip < 0.4 && dip > -0.4) { if (runStart < 0) runStart = i; continue; }
        if (runStart >= 0) { flushRun(runStart, i, cw); runStart = -1; }
        if (dip > maxDip) maxDip = dip;
        var sx = Math.floor(i * cw), sw = Math.ceil(cw) + 1;
        if (sx + sw > W) sw = W - sx;
        var dc = Math.max(-rT * 0.4, Math.min(dip, rB * 0.78));
        var yA = yP - rT, yC = yP + rB;
        if (yA > 0) ctx.drawImage(off, sx, 0, sw, yA, sx, 0, sw, yA);
        ctx.drawImage(off, sx, yA, sw, rT, sx, yA, sw, rT + dc);
        ctx.drawImage(off, sx, yP, sw, rB, sx, yP + dc, sw, rB - dc);
        if (H - yC > 0) ctx.drawImage(off, sx, yC, sw, H - yC, sx, yC, sw, H - yC);
      }
      if (runStart >= 0) flushRun(runStart, N, cw);
      if (maxDip > 0.5) {
        var aRel = Math.min(1, maxDip / (depthFrac * H));
        ctx.save();
        ctx.translate(px * W, yP + maxDip * 0.7);
        ctx.scale(1, 0.42);
        var R = 0.16 * W;
        var g = ctx.createRadialGradient(0, 0, 0, 0, 0, R);
        g.addColorStop(0, 'rgba(15,12,9,' + (0.26 * aRel).toFixed(3) + ')');
        g.addColorStop(1, 'rgba(15,12,9,0)');
        ctx.fillStyle = g;
        ctx.fillRect(-R, -R, R * 2, R * 2);
        ctx.restore();
      }
    }

    function step(t) {
      if (!running) return;
      var dt = Math.min(1 / 30, (t - lastT) / 1000 || 1 / 60);
      lastT = t;
      if (ghost) {
        ghost.t += dt;
        if (ghost.t < 0.45) { pressing = true; px = 0.5; pyT = zoneMid; pressFrac = Math.min(1, ghost.t / 0.35); }
        else if (ghost.t < 0.8) { pressing = true; pressFrac = 1; }
        else { pressing = false; ghost = null; }
      }
      var engaged = pressing || hoverFrac > 0.01;
      if (engaged) bandY += (pyT - bandY) * Math.min(1, 14 * dt);
      var sigma = 0.10, active = false;
      var frac = pressing ? pressFrac : hoverFrac;
      for (var i = 0; i < N; i++) {
        var xi = (i + 0.5) / N;
        var g = Math.exp(-((xi - px) * (xi - px)) / (2 * sigma * sigma));
        var target = engaged ? depthFrac * frac * g : 0;
        if (target > d[i]) {
          /* hand pushes down: fast follow, hand owns the speed */
          d[i] += (target - d[i]) * Math.min(1, mat.attack * dt);
          v[i] = 0;
        } else {
          /* recovery: the material's own spring */
          var a = -mat.k * (d[i] - target) - mat.c * v[i];
          v[i] += a * dt;
          d[i] += v[i] * dt;
          if (d[i] < -0.05) { d[i] = -0.05; v[i] *= -0.4; }
        }
        if (Math.abs(d[i]) > 0.0008 || Math.abs(v[i]) > 0.004) active = true;
      }
      draw();
      if (active || engaged) requestAnimationFrame(step);
      else running = false;
    }
    function wake() {
      if (!running) { running = true; lastT = performance.now(); requestAnimationFrame(step); }
    }

    function pointX(e) {
      var r = canvas.getBoundingClientRect();
      return Math.min(1, Math.max(0, (e.clientX - r.left) / r.width));
    }
    function pointY(e) {
      var r = canvas.getBoundingClientRect();
      return Math.min(zoneBot, Math.max(zoneTop, (e.clientY - r.top) / r.height));
    }
    function firePressEvent() {
      if (firedPress) return;
      firedPress = true;
      if (window.moTrack) window.moTrack('mo_feel_press', {
        firmness: firmness, material: matKey, feel: root.dataset.feel || '', page: location.pathname
      });
    }

    function bind() {
      var fine = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      canvas.addEventListener('pointerdown', function (e) {
        ghost = null;
        pressing = true; pressFrac = 1; px = pointX(e); pyT = pointY(e);
        try { canvas.setPointerCapture(e.pointerId); } catch (err) {}
        firePressEvent();
        if (e.pointerType !== 'touch') e.preventDefault();
        wake();
      });
      canvas.addEventListener('pointermove', function (e) {
        if (pressing) { px = pointX(e); pyT = pointY(e); wake(); }
        else if (fine) { px = pointX(e); pyT = pointY(e); hoverFrac = 0.22; wake(); }
      });
      function release() { pressing = false; hoverFrac = 0; wake(); }
      canvas.addEventListener('pointerup', release);
      canvas.addEventListener('pointercancel', release);
      canvas.addEventListener('pointerleave', function () { if (!pressing) { hoverFrac = 0; wake(); } });
      canvas.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          ghost = { t: 0 };
          firePressEvent();
          wake();
        }
      });
    }

    /* one-shot ghost press when the section approaches the viewport */
    var hinted = false;
    function approach() {
      if (hinted) return;
      var r = root.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.78 && r.bottom > 0) {
        hinted = true;
        window.removeEventListener('scroll', approach);
        ghost = { t: 0 };
        wake();
      }
    }

    function start() {
      if (!build()) return;
      readout();
      window.addEventListener('scroll', approach, { passive: true });
      approach();
      var rt = null;
      window.addEventListener('resize', function () {
        clearTimeout(rt);
        rt = setTimeout(function () { build(); }, 180);
      }, { passive: true });
    }
    if (img.complete && img.naturalWidth) start();
    else img.addEventListener('load', start, { once: true });
  }

  document.querySelectorAll('[data-mo-feelpress]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-mo-feelpress]');
    if (r) { delete r.dataset.fpressInit; init(r); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mo-layer-scroll"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.lscrollInit) return;
    root.dataset.lscrollInit = '1';
    var layers = Array.prototype.slice.call(root.querySelectorAll('.mo-lscroll__layer'));
    if (!layers.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.classList.add('is-static');
      return;
    }
    root.classList.add('is-anim');
    var stack = root.querySelector('.mo-lscroll__stack');
    var box = root.querySelector('.mo-lscroll__scalebox');
    var pin = root.querySelector('.mo-lscroll__pin');
    var rail = Array.prototype.slice.call(root.querySelectorAll('.mo-lscroll__railitem'));
    var centers = [], mid = 0, ticking = false;
    function measure() {
      stack.style.transform = 'none';
      box.style.height = 'auto';
      var natural = stack.offsetHeight;
      var vh = window.innerHeight;
      var coarse = window.matchMedia('(max-width: 989px)').matches;
      var budget = coarse ? vh * 0.42 : Math.max(320, vh - 330);
      var s = Math.min(1, budget / natural);
      box.style.height = (natural * s) + 'px';
      stack.style.transform = 'scale(' + s + ')';
      mid = natural / 2;
      centers = layers.map(function (l) { return l.offsetTop + l.offsetHeight / 2; });
      root.style.height = (pin.offsetHeight + vh * (coarse ? 1.1 : 1.5)) + 'px';
    }
    function frame() {
      ticking = false;
      var rect = root.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var p = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 1;
      var e = p < 0.5 ? 2 * p * p : 1 - Math.pow(-2 * p + 2, 2) / 2;
      for (var i = 0; i < layers.length; i++) {
        var pull = (mid - centers[i]) * (1 - e) * 0.9;
        layers[i].style.transform = 'translate3d(0,' + pull.toFixed(1) + 'px,0)';
        var threshold = (i + 0.6) / layers.length * 0.9;
        var on = e >= threshold;
        layers[i].style.opacity = '';
        if (rail[i]) rail[i].classList.toggle('is-active', on);
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measure(); onScroll(); }, { passive: true });
    var imgs = root.querySelectorAll('img');
    var pending = imgs.length;
    function ready() { measure(); frame(); }
    imgs.forEach(function (im) {
      if (im.complete) { if (--pending <= 0) ready(); }
      else im.addEventListener('load', function () { if (--pending <= 0) ready(); }, { once: true });
    });
    if (pending <= 0) ready();
    measure(); frame();
  }
  document.querySelectorAll('[data-mo-lscroll]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-mo-lscroll]');
    if (r) { delete r.dataset.lscrollInit; init(r); }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mo-video-scrub"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.vscrubInit) return;
    root.dataset.vscrubInit = '1';
    var video = root.querySelector('.mo-vscrub__video');
    if (!video) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fine = window.matchMedia('(pointer: fine)').matches;
    var wide = window.matchMedia('(min-width: 990px)').matches;

    if (reduce) return; /* poster only, no motion */

    /* perf budget: below-fold video loads on APPROACH, not on page load.
       Layout is untrusted until window load or first scroll (collapsed lazy
       images make everything measure "near viewport" at init — same race the
       sitewide motion engine guards against). */
    function onApproach(cb) {
      var armed = false;
      function chk() {
        var r = root.getBoundingClientRect();
        if (r.top < window.innerHeight * 1.25 && r.bottom > -200) {
          window.removeEventListener('scroll', chk);
          cb();
          return true;
        }
        return false;
      }
      function arm() {
        if (armed) return;
        armed = true;
        if (!chk()) window.addEventListener('scroll', chk, { passive: true });
      }
      if (document.readyState === 'complete') arm();
      else {
        window.addEventListener('load', arm, { once: true });
        window.addEventListener('scroll', function once() {
          window.removeEventListener('scroll', once);
          arm();
        }, { passive: true });
      }
    }

    if (root.dataset.loop === '1' || !fine || !wide) {
      /* touch / small screens: graceful ambient loop instead of scrub */
      onApproach(function () {
        video.preload = 'auto';
        video.loop = true;
        video.autoplay = true;
        video.play && video.play().catch(function () {});
      });
      return;
    }

    root.classList.add('is-scrub');
    var runway = parseInt(root.dataset.runway || '150', 10) / 100;
    var pin = root.querySelector('.mo-vscrub__pin');
    var ticking = false, dur = 0;

    function measure() {
      root.style.height = (pin.offsetHeight + window.innerHeight * runway) + 'px';
    }
    function frame() {
      ticking = false;
      if (!dur) return;
      var rect = root.getBoundingClientRect();
      var total = rect.height - window.innerHeight;
      var p = total > 0 ? Math.min(1, Math.max(0, -rect.top / total)) : 0;
      var t = p * (dur - 0.05);
      if (Math.abs(video.currentTime - t) > 0.04) video.currentTime = t;
      if (p >= 0.97 && !root.dataset.scrubDone) {
        root.dataset.scrubDone = '1';
        if (window.moTrack) window.moTrack('mo_scrub_complete', { page: location.pathname });
      }
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(frame); } }

    video.addEventListener('loadedmetadata', function () {
      dur = video.duration || 0;
      video.pause();
      measure(); frame();
    });
    if (video.readyState >= 1) { dur = video.duration || 0; video.pause(); measure(); frame(); }
    else onApproach(function () { video.preload = 'auto'; video.load(); });
    measure();
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', function () { measure(); onScroll(); }, { passive: true });
  }
  document.querySelectorAll('[data-mo-vscrub]').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var r = e.target.querySelector('[data-mo-vscrub]');
    if (r) { delete r.dataset.vscrubInit; init(r); }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
